import { Button, Space } from 'antd';
import { useIntl } from 'react-intl';
import { Helmet } from 'react-helmet';
import { useState } from 'react';
import { AppPageHeader, TabContentWrapper } from '@/components/_common';
import { PageProps } from '@/types/PageProps';
import DisableNumberTable from '@/components/Fiscal/DisableNumber/DisableNumberTable';
import DisableNumberExtraFilters from '@/components/Fiscal/DisableNumber/DisableNumberExtraFilters';
import { useDisclosure } from '@/hooks';
import InvoiceInutilizationModal from '@/components/Fiscal/Invoice/InvoiceInutilizationModal';
import { NumberInutilizationRequest } from '@/core/domain/invoice/numberInutilization/numberInutilization.types';

const DisableNumberingRangePage = ({ route }: PageProps) => {
  const intl = useIntl();

  const [modalVisible, modalAction] = useDisclosure();

  const [queryParams, setQueryParams] = useState<NumberInutilizationRequest>(
    {},
  );

  const handleCancel = async () => {
    modalAction.toggle();
  };

  return (
    <TabContentWrapper
      title={route.name}
      permissions={route.permissions}
      extra={
        <Space>
          <Button onClick={() => modalAction.toggle()} type="primary">
            {intl.formatMessage({
              id: 'invoice.disableNumberingRange.btn.newDisability',
            })}
          </Button>
        </Space>
      }
    >
      <AppPageHeader
        onSearch={(value) =>
          setQueryParams((prev) => ({ ...prev, company: value }))
        }
        extraFilters={
          <DisableNumberExtraFilters
            queryParams={queryParams}
            setQueryParams={setQueryParams}
          />
        }
      />

      <Helmet
        title={intl.formatMessage({
          id: 'invoice.disableNumberingRange.helmet.title',
        })}
      />

      <DisableNumberTable filter={queryParams} />

      <InvoiceInutilizationModal opened={modalVisible} onClose={handleCancel} />
    </TabContentWrapper>
  );
};

export default DisableNumberingRangePage;
